"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = void 0;
const uuid_1 = require("uuid");
const axios_1 = __importDefault(require("axios"));
const util_1 = require("util");
var EventType;
(function (EventType) {
    EventType["PAGEVIEW"] = "pageview";
    EventType["ACTION"] = "action";
})(EventType = exports.EventType || (exports.EventType = {}));
class TrackingService {
    constructor() {
        this.serviceUrl = null;
        this.serviceName = '';
        this.correlationResolver = () => ({});
        this.logger = {
            debug: (message) => {
                console.debug(message);
            },
            info: (message) => {
                console.info(message);
            },
            error: (message) => {
                console.error(message);
            },
            warn: (message) => {
                console.warn(message);
            }
        };
        this.configure({
            serviceUrl: process.env.TRACKING_SERVICE_URL,
            serviceName: process.env.SERVICE_NAME
        });
    }
    configure(opts) {
        if (opts.serviceUrl) {
            this.serviceUrl = new URL(opts.serviceUrl);
            this.client = axios_1.default.create({
                baseURL: this.serviceUrl.origin,
                headers: { 'Content-Type': 'application/json' }
            });
        }
        if (opts.serviceName) {
            this.serviceName = opts.serviceName;
        }
        if (opts.correlationResolver) {
            this.correlationResolver = opts.correlationResolver;
        }
        if (opts.logger) {
            this.logger = opts.logger;
        }
    }
    trackAction(token, eventValue, eventData = {}, correlation = {}, meta) {
        return this.send(token, {
            id: undefined,
            timestamp: undefined,
            serviceName: undefined,
            eventType: EventType.ACTION,
            eventValue,
            eventData,
            correlation,
            meta
        });
    }
    trackPageView(token, eventValue, eventData = {}, correlation = {}, meta) {
        return this.send(token, {
            id: undefined,
            timestamp: undefined,
            serviceName: undefined,
            eventType: EventType.PAGEVIEW,
            eventValue,
            eventData,
            correlation,
            meta
        });
    }
    send(token, event) {
        const url = this.getServiceUrl().origin + this.getServicePath({ event: 'events' });
        this.addTrackingParams(event);
        this.logger.debug((0, util_1.format)('Track action %s', JSON.stringify(event)));
        return this.client.post(url, event, {
            headers: { Authorization: `Bearer ${token}` }
        });
    }
    getServiceUrl() {
        return this.serviceUrl;
    }
    getServiceName() {
        return this.serviceName;
    }
    getServicePath(params = {}) {
        const servicePath = this.getServiceUrl().pathname.split('/').filter(s => s.length);
        return ['', ...servicePath, 'api', ...Object.values(params)].join('/');
    }
    addTrackingParams(event) {
        event.id = (0, uuid_1.v4)();
        event.timestamp = new Date();
        event.serviceName = this.serviceName;
        this.addCorrelation(event);
    }
    addCorrelation(event) {
        event.correlation = Object.assign({}, this.correlationResolver(event), event.correlation || {});
    }
}
exports.default = new TrackingService();
